<template>
    <div>
        <le-search-form @reset="handlerRest" @search="handlerSearch" >
            <le-select-local-search label="退款来源" v-model="pageParam.params.refundType" :options="refundTypeDic" />
            <le-date-range 
                label="退款时间" 
                :minDate.sync="pageParam.params.startTime" 
                :maxDate.sync="pageParam.params.endTime" 
                valueFormat="yyyy-MM-dd HH:mm:ss" 
                :defaultTime="['00:00:00','23:59:59']" />
        </le-search-form>
        <le-pagview ref="userRefundPage" @setData="setTableData" :pageParam="pageParam" v-if="pageParam">
            <el-table :data="tabledata">
                <el-table-column label="退款金额" prop="typeText">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.refundAmount) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="退款来源" prop="content">
                    <template slot-scope="{ row }">
                        <span>{{ row.refundType | initDic(refundTypeDic) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="退款方式" prop="content">
                    <template slot-scope="{ row }">
                        <span>{{ row.refundWay | initDic(refundWayDic) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="退款原因" prop="orderId">
                    <template slot-scope="{ row }">
                        <span>{{ row.refundMsg || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="退款状态" prop="activePower">
                    <template slot-scope="{ row }">
                        <span>{{ util.initDic(row.refundStatus, 'refundStatus') }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="退款时间" prop="operatorUserPhone">
                    <template slot-scope="{ row }">
                        <span>{{ row.refundTime || '-' }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </le-pagview>
    </div>
</template>

<script>
    import util from '@/utils/util.js'
    export default {
        data() {
            return {
                util: util,
                pageParam: {
                    url: this.$Config.apiUrl.userOrCardRefundPage,
                    method: "post",
                    params: {
                        "balanceId": this.userId,
                        "endTime": "",
                        "payType": "0",
                        "refundType": "",
                        "startTime": "",
                        "userId": this.userId
                    },
                    freshCtrl: 1,
                },
                tabledata: [],
                refundTypeDic: [],
                refundWayDic: [
                    {
                        label: '线上',
                        value: '0'
                    },
                    {
                        label: '线下',
                        value: '1'
                    },
                ]
            }
        },
        props:['userId','phone'],
        mounted () {
            this.$getDic('userRechargeRefundType','select').then(res=>{ this.refundTypeDic = res; })
        },
        methods:{
            handlerRest() {
                this.pageParam.params = {
                    "balanceId": this.userId,
                    "endTime": "",
                    "payType": "0",
                    "refundType": "",
                    "startTime": "",
                    "userId": this.userId
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs.userRefundPage.pageNum = 1
                this.pageParam.freshCtrl++;
            },
            setTableData (datas) {
                this.tabledata = datas.map(item=>{
                    return {
                        ...item,
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
   
</style>